export default __webpack_public_path__ + "static/media/image.19d025db.png";